import React, { useMemo } from 'react';

import Autocomplete from 'src/components/input/autocomplete/Autocomplete';
import useTeamMembers from 'src/services/api/team/members/use-team-members';
import {ProfileImageRounded} from 'src/components/ProfileImageRounded';
import Flex from 'src/components/flex/Flex';

type Props = Omit<React.ComponentProps<typeof Autocomplete>, 'options'>;

export default function SelectTeamMember({
    value,
    ...props
}: Props) {
    const { data: teamMembers } = useTeamMembers();

    const options = useMemo(() => {
        if (!teamMembers) {
            return [];
        }

        return teamMembers
            .map((teamMember) => ({
                value: teamMember.uuid,
                label: teamMember.name,
            }));
    }, [teamMembers]);

    return (
        <Autocomplete {...props} value={value} options={options} renderOption={(_props, option) => {
            const member = teamMembers?.find((m) => m.uuid === option.value);
            return (<li {..._props} key={option.value}>
                <Flex alignItems="center" gap={1}>
                    <ProfileImageRounded url={member?.profile_photo_url} width={25} height={25} showEmptyImage userName={member?.name} />
                    {option.label}
                </Flex>
            </li>
            );
        }}
        />
    );
}
